import { createContext } from 'react';
export const AdminPermissionContext = createContext({
    saveUserPermissions: () => { },
});
